  import rohanPic from "../Assets/rohan-rana-pic.png";

  export const profile = {
    name: "Rohan Rana",
    titles: ["Java Backend Developer", "Spring Boot Developer", "Software Engineer"],
    bio: [
      "Java Backend Developer with 2 years of hands-on experience building Spring Boot microservices and RESTful APIs.",
      "Specialized in Spring Cloud components, Docker containerization, JWT-based security, and database optimization using Hibernate and JPA.",
      "Experienced with CI/CD pipelines, production support, and building scalable solutions handling 40K+ daily API requests.",
    ],
    image: rohanPic,
    social: {
      email: "rohan.rana.7351@gmail.com",
      phone: "+91 7983475326",
      linkedin: "https://www.linkedin.com/in/rohan-rana-228a2b227/",
      github: "https://github.com/Rohan7351",
    },
  };
